import { useFormatter } from 'next-intl';
import { FC } from 'react';
import Cork from 'src/components/icons/Cork';

interface Props {
  loyaltyPoints: number;
  // Add proper types (es. numberSize: "xs" | "sm" ecc.)
  corkSize?: string;
  corkColor?: string;
  numberSize?: string;
  numberColor?: string;
  numberWeight?: string;
}

const Corks: FC<Props> = (
  props: Props = {
    corkSize: '5',
    corkColor: 'secondary',
    numberSize: '2xl',
    numberColor: 'secondary',
    numberWeight: 'bold',
    loyaltyPoints: 0,
  },
) => {
  const corkClasses = [
    `tw-text-${props.corkColor}`,
    `tw-h-${props.corkSize}`,
    `tw-w-${props.corkSize}`,
  ].join(' ');

  const numberClasses = [
    'tw-mr-1',
    `tw-text-${props.numberColor}`,
    `tw-font-${props.numberWeight}`,
    `tw-text-${props.numberSize}`,
  ].join(' ');

  const formatter = useFormatter();

  return (
    <div className="tw-inline-flex tw-items-center">
      <span className={numberClasses}>
        {formatter.number(props.loyaltyPoints, { localeMatcher: 'best fit' })}
      </span>
      <Cork className={corkClasses} />
    </div>
  );
};

export default Corks;
